import React from 'react'
import { Checkbox, Grid } from 'semantic-ui-react'
import { Choices } from '../../util'

const ValueIndicatorForm = ({ translate, isFormDisabled = true, partyDependency }) => {
  return (
    <div className='formContainer'>
      <Grid.Row>
        <Grid.Column style={{display:'flex',justifyContent:'space-between',background:'white'}}>
          {Choices.map(({ label, value }) => (
            <Checkbox
              key={value}
              style={{padding:'.5em'}}
              disabled={isFormDisabled}
              label={<label>{translate(label, { ns: ['default', 'lineItem'] })}</label>}
              checked={partyDependency?.includes(value)}
            />
          ))}
        </Grid.Column>
      </Grid.Row>
    </div>
  )
}
export default ValueIndicatorForm
ValueIndicatorForm.defaultProps = {
  translate: (value) => value,
}
